import React from 'react'
import Loader from 'react-loader-advanced'
import { SpringDataTable } from 'isotope-client'
import CircularProgress from '@material-ui/core/CircularProgress'

/**
 * Hauteur minimale réservée pendant un chargement : le voile et le message du loader sont
 * positionnés en absolu sur toute la hauteur du conteneur. Sans contenu à afficher (premier
 * montage, ou liste vidée), ce conteneur se réduirait à 0 et le loader serait invisible.
 */
const HAUTEUR_MIN_LOADER = 120

/**
 * Loader pour la springdatatable
 */
const SpringDataTableWithLoader = ({ loaderStyle = {}, messageStyle = {}, hideContentOnLoad = true, noResultFragment, ...props }) => {
    const [loading, setLoading] = React.useState(true)
    return <Loader
        show={loading}
        message={<CircularProgress />}
        backgroundStyle={{ backgroundColor: 'rgba(255,255,255,0.5)' }}
        messageStyle={messageStyle}
        hideContentOnLoad={hideContentOnLoad}
        style={loading ? { minHeight: HAUTEUR_MIN_LOADER, ...loaderStyle } : loaderStyle}
    >
        <SpringDataTable
            {...props}
            // tant qu'un appel est en cours, la liste n'est pas "sans résultat" mais "pas encore chargée"
            noResultFragment={loading ? null : noResultFragment}
            preFetch={() => setLoading(true)}
            postFetch={() => {
                // Ajout d'un timer pour laisser le temps aux sélecteurs de réaliser leurs traitements
                const timer = setTimeout(() => {
                    setLoading(false)
                }, 1000)
                return () => clearTimeout(timer)
            }}
        />
    </Loader>

}

export default SpringDataTableWithLoader
